export default __webpack_public_path__ + "static/media/marketing.77d32c01.svg";